require("../modules/language_and_default_ship_to/language_and_ship_to_switcher");
require("./js/accordion");
require("./js/sendinblue");
require("./js/product_page");
require("./js/ajax-add-to-cart");
require("./js/cart");
require("./js/checkout");
require("./js/account");
require("./js/header");
require("./js/video_block");
require("../modules/attribute_gallery_images/attribute_change");
require("../modules/popup_for_customer_location/popup_for_customer_location");

// Style sheets
require("./scss/main.scss");
